import { api } from 'utility';
import { getChangeUserPasswordUrl } from 'URLs';
export function changePassword(params) {
  return api.put(getChangeUserPasswordUrl(), params);
}

export default {
  changePassword,
};
